import styled from 'styled-components';

export const MissingValue = styled.strong`
    color: var(--error-normal);
`;
